import React, {useEffect, useState} from "react";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {CalcSelectCar} from "./CalcSelectCar";
import {useCalcContext} from "../../contexts/CalcContext";
import useEnterEffect from "../../hooks/useEnterEffect";
import {useLocation} from "react-router-dom";
import {CalcPageSelectLocation} from "./CalcPageSelectLocation";
import {CalcPagePricing} from "./CalcPagePricing";
import {DeskingModal} from "../PricingListPage/DeskingModal";
import {DealModal} from "../PricingListPage/DealModal";
import {useModalsStore} from "../../stores/modalsStore";
import {useShallow} from "zustand/react/shallow";
import classnames from "classnames";

export const CalcPageInfo = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    let location = useLocation();
    const [isCreatingLease, setIsCreatingLease] = useState(false)
    const [isCreatingPurchase, setIsCreatingPurchase] = useState(false)
    const {
        carState,
        calcState,
        getLeadId,
    } = useCalcContext()

    const {
        openModal,
        hasModalOpen,
    } = useModalsStore(
        useShallow((state) => ({
            openModal: state.openModal,
            closeModal: state.closeModal,
            hasModalOpen: state.hasModalOpen,
        }))
    )

    const onCreate = (newLeaseData) => {
        if (getLeadId()) {
            window.onunload = function() {
                if (window.opener && !window.opener.closed) {
                    window.opener.onLeadCreate(newLeaseData);
                }
            };
            window.close();
        } else {
            if (isTabletOrMobile) {
                window.open(`/quotes/${newLeaseData.id}`, "_self")
            } else {
                openModal({
                    element: DealModal,
                    id: "DealModal",
                    props: {id: newLeaseData.id}
                })
            }
        }
    }

    const deskDeal = (isPurchase, isOnePay) => {
        isPurchase ? setIsCreatingPurchase(true) : setIsCreatingLease(true)

        const deskingData = structuredClone(calcState)
        delete deskingData.location
        delete deskingData.location_id

        deskingData.is_purchase = isPurchase
        deskingData.is_one_pay = isOnePay

        isPurchase ? setIsCreatingPurchase(false) : setIsCreatingLease(false)
        let mileage = deskingData.mileage
        if (['Ford', 'Lincoln'].includes(carState?.make)) {
            mileage = deskingData.mileage_alt
        }

        openModal({
            element: DeskingModal,
            id: "DeskingModal",
            props: {
                onSave: (data) =>  onCreate(data),
                isDeskingContext: false,
                ...deskingData,
                mileage: mileage
            }
        })
    }

    const isCalculatePath = location.pathname.split('/')[1] === 'calculate'

    useEnterEffect(function enterDeskLease(){
        if (
            calcState.base_car_id &&
            calcState.msrp &&
            calcState.cost &&
            isCalculatePath
        ) {
            if (!hasModalOpen()) {
                deskDeal(false, false)
            }
        }
    }, [calcState, hasModalOpen])

    return (
        <div className={classnames("calc-grid", { mobile: isTabletOrMobile })}>
            <CalcSelectCar />
            <CalcPageSelectLocation />
            <CalcPagePricing deskDeal={deskDeal}/>
        </div>
    )
}